import { render } from "./MenuMobile.vue?vue&type=template&id=2a8b1e08"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/MenuMobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8b1e08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8b1e08', __exports__)) {
    api.reload('2a8b1e08', __exports__)
  }
  
  module.hot.accept("./MenuMobile.vue?vue&type=template&id=2a8b1e08", () => {
    api.rerender('2a8b1e08', render)
  })

}


export default __exports__